import { useModal, create } from '@ebay/nice-modal-react';
import { useMemo } from 'react';

import { LoyaltyIdBarcodeScanActionSheetController } from './loyalty-id-barcode-scan-action-sheet.controller';

const LoyaltyIdBarcodeScanActionSheetModal = create(LoyaltyIdBarcodeScanActionSheetController);

export const useLoyaltyIdBarcodeScanActionSheet = () => {
  const { show, hide } = useModal(LoyaltyIdBarcodeScanActionSheetModal);
  return useMemo(() => ({ open: show, close: hide }), [hide, show]);
};
